/* eslint-disable @typescript-eslint/no-explicit-any */
import {forkJoin, Observable, of} from 'rxjs';

/**
 * Invoking forkJoin with an empty array results in subscribers of the resulting Observable never being invoked, as no values are
 * emitted from the Observable returned by forkJoin. In a pure Observable world this isn't an issue, however, in our world where
 * we are migrating from Promises to Observables, simply replacing one with the other isn't always enough, and these subtle bugs
 * can be introduced - Previous Promise chains would always be invoked, but a migrated subscription off a forkJoin may never be
 * invoked.
 * This wraps forkJoin to provide at least one observable that emits a value to enable clients to use subscriptions on the
 * returned observable as they would have used a Promise.
 * @param observables the array of observables to pass to forkJoin
 * @param emptyDefault (optional) the default value passed to of() and returned if the observables array is empty. If this is not
 *                     provided, and observables is empty, an empty array is passed to of()
 */
export function forkJoinDefaultIfEmpty(observables: Observable<any>[], emptyDefault?: any) {
    return observables.length ? forkJoin(observables) : of(arguments.length > 1 ? emptyDefault : []);
}
